import { DocTypesList } from "../../../../DocTypes"
import { Helmet } from "react-helmet-async"

const OrganizationDocTypesPage = () => {
	return (
		<>
			<Helmet>
				<title>Document Types | Org</title>
			</Helmet>
			<DocTypesList />
		</>
	)
}

export default OrganizationDocTypesPage
